window.buildAutocomplete = function(selector, merchant_id, onSelect = null) {
  new autoComplete({
    selector: selector,
    source: function(term, response){
      var data = new FormData();
      data.append( "json", JSON.stringify({
        merchant_id: merchant_id,
        term: term
      }));

      fetch('/api/customers', { method: 'POST', body: data }).then(function(resp) {
        // Convert to JSON
        return resp.json();
      }).then(function(data) {
        response(data)
      });
    },
    renderItem: function (item, search){
      search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
      return `<div class="autocomplete-suggestion" data-first="${item.first_name}" data-last="${item.last_name}" data-email="${item.email}">${item.first_name} ${item.last_name} (${item.email})</div>`;
    },
    onSelect: function(e, term, item){
      if (onSelect) {
        onSelect(e, term, item);
      }
    }
});
};

window.buildAutocompleteMerchantSearch2 = function(selector, merchant_id, onSelect = null) {
  new autoComplete({
      selector: selector,
      source: function(term, response){
          var data = new FormData();
          data.append( "json", JSON.stringify({
              merchant_id: merchant_id,
              term: term
          }));

          fetch('/api/merchant', { method: 'POST', body: data }).then(function(resp) {
              // Convert to JSON
              return resp.json();
          }).then(function(data) {
              response(data)
          });
      },
      renderItem: function (item, search){
          search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
          var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
          return `<div class="autocomplete-suggestion" data-name="${item.name}" data-id="${item.id}" data-stripe-user-id="${item.stripe_user_id}" data-stripe-currency="${item.stripe_currency}" data-stripe-fee="${item.stripe_fee}" data-stripe-customer-id="${item.stripe_customer_id}" data-stripe-publishable-key="${item.stripe_publishable_key}">${item.name}</div>`;
      },
      onSelect: function(e, term, item){
          if (onSelect) {
              onSelect(e, term, item);
          }
      }
  });
};

window.buildAutocompleteMerchantSearch = function(selector, merchant_id, onSelect = null) {
    new autoComplete({
        selector: selector,
        source: function(term, response){
            var data = new FormData();
            data.append( "json", JSON.stringify({
                merchant_id: merchant_id,
                term: term
            }));

            fetch('/api/merchant', { method: 'POST', body: data }).then(function(resp) {
                // Convert to JSON
                return resp.json();
            }).then(function(data) {
                response(data)
            });
        },
        renderItem: function (item, search){
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            return `<div class="autocomplete-suggestion" data-name="${item.name}" data-id="${item.id}">${item.name}</div>`;
        },
        onSelect: function(e, term, item){
            if (onSelect) {
                onSelect(e, term, item);
            }
        }
    });
};


// WEBPACK FOOTER //
// ./resources/assets/website/scripts/autocomplete-input.js